// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//import 'zone.js/dist/zone-error';
import { version } from '../../package.json';

export const environment = {
  production: false,
  apiKeyAut: 'AIzaSyBRMSHbh8aPwDbbWzxwjS0pl0nSfQtlrEk',
  apiEndPoint: 'https://api-dev.waypoint.cl/indicadores',
  endPoint: window.location.hostname.endsWith('tranciti.com')?'https://app-dev.tranciti.com' :'https://id2.waypoint.cl',
  endPointApiInstantanea: 'https://rt-dev.waypoint.cl/realtimedata/latest',
  useMockLocalizacion: false,
  endPointApiWebsocket: 'wss://rt-dev.waypoint.cl/realtimedata',
  endPointApiWebsocketTicket: 'https://rt-dev.waypoint.cl/realtimedata/ws-ticket',
  endpointPermisos: 'https://api-dev.waypoint.cl/permissions-service/getPermisos',
  endpointMenu: 'https://api-dev.waypoint.cl/menu-service/getMenu',
  endPointApiAlert: 'https://api-dev.waypoint.cl/lastmile',
  endpointValidacionCaptcha: 'https://mtvjrgeiib.execute-api.us-west-1.amazonaws.com/prod/captcha',
  endPointApiVehicleOnRoute: 'https://api-dev.waypoint.cl/lastmile/route/checkVehicleStatusOnRouteMultiple',
  appLogin: 'https://app-dev.tranciti.com/login/#',
  appLocalizacionInstantanea: 'https://app-dev.tranciti.com/localizacion/localizacion-instantanea/',
  endpointQuicksight: 'https://m4zyp56zld.execute-api.us-east-1.amazonaws.com/bi',
  locationIQ: {
    endPointReverseGeocoding: 'https://kp35pfgfqdxl7qduevftbwxrvi0vwviq.lambda-url.us-west-1.on.aws',
  },
  google: {
    siteKey: '6LeA2hEaAAAAABiZm9rSPYoUcdX4F00DcR3yGs2O',
    cantidadIntentos : '3'
  },
  rbacEndpoint: "https://auth-dev.waypoint.cl/rbac",
  coreEndpoint: "https://api-dev.waypoint.cl/core",
  fruitsWorkspace: 'RSP6sTcwLw9hOx09',
  appVersion: version + '-DEV',
  idClientSaesa: 2038, // ID del cliente que usa filtros jerárquicos
  // Usados por /dashboard/logclaude para el pairing del MCP de paradas de
  // emergencia. Este JS es público (bundle de frontend): mcpApiKey queda
  // visible para cualquiera que abra devtools, así que no debería ser el
  // mismo secreto de acceso amplio que usa el backend/MCP hoy — pedir uno
  // dedicado y acotado antes de reemplazar este placeholder.
  mcpAuthEndpoint: '',
  mcpApiKey: '',
  mcpIdClient: 0
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
